export default __webpack_public_path__ + "static/media/intel3470.d87d7227.jpg";